import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {TriggerWithTooltip} from '#components/m/MeineAzubis/TriggerWithTooltip'

export function AusbildungsberufCell(props) {
  const {azubi} = props

  return (
    <div className="ausbildungsberuf-cell">
      {azubi.newAusbildungsberuf && (
        <div className="berufwechsel-cell">
          <TriggerWithTooltip
            text={i18n.t('meineazubis_berufwechsel_tooltip', [azubi.name, azubi.newAusbildungsberufString])}
            placement="top"
            modifiers={['dark', 'nopadding', 'margin-bottom']}>
            <div className="berufwechsel-indicator" />
          </TriggerWithTooltip>
        </div>
      )}
      {azubi.newAufbauAusbildungsberuf && (
        <div className="berufwechsel-cell">
          <TriggerWithTooltip
            text={i18n.t('meineazubis_berufwechsel_aufbauausbildung_tooltip', [
              azubi.name,
              azubi.newAufbauAusbildungsberufString,
            ])}
            placement="top"
            modifiers={['dark', 'nopadding', 'margin-bottom']}>
            <div className="berufwechsel-indicator" />
          </TriggerWithTooltip>
        </div>
      )}
      <TriggerWithTooltip text={azubi.ausbildungsberufFormatted} modifiers={['dark', 'nopadding']}>
        <span>{azubi.ausbildungsberufFormatted}</span>
      </TriggerWithTooltip>
    </div>
  )
}

AusbildungsberufCell.propTypes = {
  azubi: PropTypes.shape({
    ausbildungsberufFormatted: PropTypes.any,
    name: PropTypes.string,
    newAusbildungsberuf: PropTypes.number,
    newAufbauAusbildungsberuf: PropTypes.string,
  }),
}
